module.exports = "<select #companySelect (change)=\"onCompanySelected(companySelect.value)\" [(ngModel)]=\"companyid\" [ngStyle]=\"options?.style\" [class]=\"options?.class\">\r\n  <option value=\"-1\">{{ emptyOptionLabel }}</option>\r\n  <option [value]=\"company.id\" *ngFor=\"let company of companies\">{{company.company_name}}</option>\r\n</select>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/comapany-selector/company-selector.component.html
// module id = ./src/app/shared/comapany-selector/company-selector.component.html
// module chunks = main